export default "__VITE_ASSET__BQw1aEYa__"